<ion-button fill="clear" color="dark" class="filter-btn">
  <ng-container *ngIf="filterModel.type === 'SELECT_FILTER'">
    <ion-select
      class="filter-btn__select"
      [value]="filterModel.selectedValues"
      (ionChange)="onSelectedItemsUpdate($event)"
      [selectedText]="filterModel.displayName"
      [disabled]="!!!filterModel.items.length"
      [interfaceOptions]="dropdownInterfaceOptions"
      multiple="true"
    >
      <ion-select-option *ngFor="let option of filterModel.items" [value]="option.value">{{
        option.value
      }}</ion-select-option>
    </ion-select>
  </ng-container>

  <ng-container *ngIf="filterModel.type === 'DATE_FILTER'">
    <ion-select
      class="filter-btn__select"
      interface="popover"
      [value]="filterModel.selectedValues[0]"
      (ionChange)="onSelectedItemsUpdate($event)"
      [selectedText]="filterModel.text"
      [disabled]="!!!filterModel.items.length"
      [interfaceOptions]="dropdownInterfaceOptions"
    >
      <ion-select-option *ngFor="let option of filterModel.items" [value]="option.value">{{
        option.displayText || option.value
      }}</ion-select-option>
    </ion-select>
  </ng-container>
</ion-button>
